import LegalPage from './LegalPage'

export default function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy">
      <h2>1. Information We Collect</h2>
      <p>
        We collect information that you provide directly to us, including when you:
      </p>
      <ul>
        <li>Contact us through our website</li>
        <li>Sign up for our services</li>
        <li>Create an account</li>
        <li>Subscribe to our newsletter</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>
        We use the information we collect to:
      </p>
      <ul>
        <li>Provide and maintain our services</li>
        <li>Respond to your requests and inquiries</li>
        <li>Send you technical notices and updates</li>
        <li>Improve our services</li>
      </ul>

      <h2>3. Information Sharing</h2>
      <p>
        We do not sell, trade, or rent your personal information to third parties. 
        We may share your information only in the following circumstances:
      </p>
      <ul>
        <li>With your consent</li>
        <li>To comply with legal obligations</li>
        <li>To protect our rights and property</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We implement appropriate security measures to protect your personal information. 
        However, no method of transmission over the Internet is 100% secure.
      </p>

      <h2>5. Your Rights</h2>
      <p>
        You have the right to:
      </p>
      <ul>
        <li>Access your personal information</li>
        <li>Correct inaccurate information</li>
        <li>Request deletion of your information</li>
        <li>Opt-out of marketing communications</li>
      </ul>
    </LegalPage>
  )
}

